import React, { useContext, useState } from "react";
import Navbar from "./Navbar/Navbar";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthProvider/AuthProvider";
import toast from "react-hot-toast";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import ScrollToTop from "../../scrollToTop";
import { HashLink } from "react-router-hash-link";

const Header = () => {
  const { user, logOut } = useContext(AuthContext);
  const userAccessToken = user?.stsTokenManager?.accessToken;
  const [isOpen, setIsOpen] = React.useState(false);
  const [search, setSearch] = useState("");
  const [searchBarSection, setSearchBarSection] = useState(false);
  const navigation = useNavigate();

  const handleLogOut = () => {
    logOut()
      .then((res) => {
        toast.success("Logged out!");
        toggleCloseDrawer();
      })
      .catch((err) => {
        console.error(err);
        toast.error("Something went wrong!");
      });
  };

  const handleSearchBar = () => {
    setSearchBarSection(!searchBarSection);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const queryParams = {};
    if (search.length > 0) {
      queryParams["search"] = search;
    }
    // navigation({
    //   pathname: `/cars`,
    //   search: new URLSearchParams(queryParams).toString(),
    // });
  };

  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };
  const toggleCloseDrawer = () => {
    setIsOpen(false);
  };

  const handleToast = () => {
    toast.error("You haven't Logged In");
    setIsOpen(false);
  };
  console.log(user, "i am the user");

  return (
    <div>
      <ScrollToTop />
      <Navbar></Navbar>
      <header
        className="header-area style-1 header-bottom-margin"
        style={{ background: "rgba(19,20,26,0.9)" }}
      >
        <div className="header-logo d-lg-none d-flex">
          <Link className="font-bold text-xl" style={{ color: "white" }} to="/">
            Arjan Motors
          </Link>
        </div>
        <div className="main-menu">
          <div className="mobile-logo-area d-lg-none d-flex justify-content-between align-items-center">
            <div className="mobile-logo-wrap">
              <a href="index.html" title="arjanMotors">
                <img
                  className="img-fluid"
                  src="wp-content/plugins/arjanMotors-core/inc/theme-options/images/logo/logo.svg"
                  alt="arjanMotors"
                />
              </a>
            </div>
          </div>
          {/* Main Menu */}
          <div className="menu-main-menu-container">
            <ul id="menu-main-menu" className="menu-list">
              <li
                id="menu-item-1468"
                className="menu-item menu-item-type-taxonomy menu-item-object-vehicle-category menu-item-1468"
              >
                <NavLink
                  to="/"
                  activeClassName="active"
                  style={{ paddingLeft: "20px" }}
                >
                  Home
                </NavLink>
                <i className="bi bi-plus dropdown-icon" />
              </li>
              <li
                id="menu-item-1468"
                className="menu-item menu-item-type-taxonomy menu-item-object-vehicle-category menu-item-1468"
              >
                <NavLink to="/about" activeClassName="active">
                  About us
                </NavLink>
                <i className="bi bi-plus dropdown-icon" />
              </li>

              <li
                id="menu-item-1468"
                className="menu-item menu-item-type-taxonomy menu-item-object-vehicle-category menu-item-1468"
              >
                <NavLink to="/cars" activeClassName="active">
                  Car Inventory
                </NavLink>
                <i className="bi bi-plus dropdown-icon" />
              </li>
              <li
                id="menu-item-1468"
                className="menu-item menu-item-type-taxonomy menu-item-object-vehicle-category menu-item-1468"
              >
                <NavLink to="/contact-us" activeClassName="active">
                  Contact Us
                </NavLink>
                <i className="bi bi-plus dropdown-icon" />
              </li>
              <li
                id="menu-item-1468"
                className="menu-item menu-item-type-taxonomy menu-item-object-vehicle-category menu-item-1468"
              >
                <NavLink
                  to={userAccessToken ? "/dashboard/add-product" : "/login"}
                  onClick={userAccessToken ? "" : handleToast}
                  activeClassName="active"
                >
                  Sell With Us
                </NavLink>
                <i className="bi bi-plus dropdown-icon" />
              </li>
              {userAccessToken ? (
                <li
                  id="menu-item-1468"
                  className="menu-item menu-item-type-taxonomy menu-item-object-vehicle-category menu-item-1468"
                >
                  <NavLink to="/dashboard" activeClassName="active">
                    Dashboard
                  </NavLink>
                  <i className="bi bi-plus dropdown-icon" />
                </li>
              ) : (
                ""
              )}
            </ul>
          </div>
          <div className="topbar-right d-lg-none d-block">
            <a href="#" data-bs-toggle="modal" data-bs-target="#sellUsModal01">
              <svg
                width={16}
                height={16}
                viewBox="0 0 18 18"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M17.5588 0C17.447 0.00287726 17.3409 0.0492946 17.2629 0.129351L15.4245 1.97099L14.8707 1.4164C14.5627 1.10919 14.2078 0.938606 13.8585 0.928904C13.6483 0.923245 13.4543 0.953158 13.2231 0.985496L10.2237 1.40265C9.12021 1.55626 8.55995 2.02839 7.84852 2.69132L0.470643 9.56715C0.467641 9.5698 0.464677 9.5725 0.46175 9.57523C0.142414 9.89053 0.00416943 10.3206 0.000127199 10.7442C-0.00472348 11.1679 0.12867 11.6166 0.484386 11.9205L0.460133 11.8971L6.10309 17.5417L6.08045 17.5174C6.38443 17.8731 6.8323 18.0057 7.25674 18.0009C7.68036 17.9968 8.11127 17.8586 8.42575 17.54C8.42849 17.5368 8.43119 17.5336 8.43384 17.5303L8.94073 16.9863L10.9586 17.7381C11.1627 17.8161 11.3805 17.8522 11.5988 17.8442C11.8172 17.8361 12.0317 17.7841 12.2295 17.6912C12.6135 17.5109 12.9474 17.2062 13.101 16.7858L15.3161 10.1452C15.9758 9.4378 16.4455 8.87674 16.5983 7.77725L17.0155 4.77792C17.0478 4.5467 17.0777 4.35186 17.0721 4.14248C17.0624 3.79323 16.8926 3.43913 16.5846 3.1303L16.03 2.57652L17.87 0.736494C17.932 0.676327 17.9743 0.598838 17.9915 0.51419C18.0086 0.429542 17.9998 0.341686 17.9661 0.262143C17.9325 0.182601 17.8756 0.115085 17.8029 0.0684494C17.7302 0.0218141 17.6451 -0.00176348 17.5588 0.000808484V0ZM13.8351 1.78505C14.0032 1.78909 14.0372 1.79394 14.2643 2.02192L14.8189 2.57571L13.8351 3.5604C13.6631 3.47636 13.4743 3.43241 13.2829 3.43185C12.5779 3.43185 11.9967 4.01393 11.9967 4.71809C11.9967 5.42306 12.5779 6.00352 13.2821 6.00352C13.9871 6.00352 14.5683 5.42306 14.5683 4.71809C14.5683 4.52083 14.5214 4.33408 14.4406 4.16592L15.4245 3.18123L15.9783 3.73583C16.2062 3.963 16.2111 3.99696 16.2151 4.16431C16.2104 4.33015 16.1942 4.49547 16.1666 4.65907L15.7503 7.65841C15.6209 8.58812 15.342 8.85976 14.6831 9.56796L7.81537 16.9369C7.70462 17.0493 7.47583 17.1407 7.24704 17.1431C7.01825 17.1463 6.8226 17.0647 6.73286 16.9596C6.72537 16.9512 6.71755 16.9431 6.70942 16.9353L1.06647 11.2908C1.05869 11.2826 1.0506 11.2748 1.04221 11.2673C0.937116 11.1784 0.854655 10.9819 0.857888 10.7531C0.860314 10.5252 0.951668 10.2956 1.06404 10.1848L8.43303 3.31786C9.14123 2.65817 9.41286 2.38006 10.3426 2.25071L13.3419 1.83356C13.5731 1.80122 13.7348 1.78181 13.8351 1.78505ZM13.2829 4.28881C13.5246 4.28881 13.7114 4.47637 13.7114 4.71809C13.7114 4.95982 13.5246 5.14657 13.2829 5.14657C13.0404 5.14657 12.8544 4.95982 12.8544 4.71809C12.8544 4.47637 13.0404 4.28881 13.2829 4.28881ZM5.99314 8.99881C5.90784 8.99872 5.82446 9.0241 5.75367 9.07168C5.68288 9.11926 5.6279 9.18689 5.59578 9.2659C5.56365 9.34492 5.55584 9.43172 5.57334 9.5152C5.59084 9.59868 5.63286 9.67504 5.69401 9.7345L8.26568 12.3054C8.6699 12.7096 9.27624 12.1032 8.87201 11.699L6.30035 9.12816C6.26038 9.08717 6.2126 9.05461 6.15984 9.03239C6.10707 9.01017 6.05039 8.99876 5.99314 8.99881ZM4.70771 10.2834C4.62224 10.2832 4.53865 10.3085 4.46769 10.3561C4.39672 10.4037 4.34161 10.4715 4.30945 10.5507C4.27729 10.6299 4.26955 10.7168 4.28721 10.8005C4.30488 10.8841 4.34714 10.9605 4.40858 11.0199L6.98025 13.5908C7.38447 14.0217 8.01749 13.3879 7.58658 12.9845L5.01573 10.4144C4.9758 10.373 4.92795 10.3401 4.87503 10.3176C4.82212 10.2951 4.76521 10.2835 4.70771 10.2834ZM13.9094 11.6537L12.2958 16.4907C12.2408 16.6386 12.071 16.8181 11.8641 16.9151C11.6571 17.0121 11.4493 17.0097 11.32 16.9612L9.57213 16.3072L13.9094 11.6537Z"></path>
              </svg>
              SELL WITH US{" "}
            </a>
            <a href="wishlist/index.html">
              <svg
                width={16}
                height={16}
                viewBox="0 0 14 14"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M7.00012 2.40453L6.37273 1.75966C4.90006 0.245917 2.19972 0.76829 1.22495 2.67141C0.767306 3.56653 0.664053 4.8589 1.4997 6.50827C2.30473 8.09639 3.97953 9.99864 7.00012 12.0706C10.0207 9.99864 11.6946 8.09639 12.5005 6.50827C13.3362 4.85803 13.2338 3.56653 12.7753 2.67141C11.8005 0.76829 9.10019 0.245042 7.62752 1.75879L7.00012 2.40453ZM7.00012 13.125C-6.41666 4.25953 2.86912 -2.65995 6.84612 1.00016C6.89862 1.04829 6.95024 1.09816 7.00012 1.14979C7.04949 1.09821 7.10087 1.04859 7.15413 1.00104C11.1302 -2.6617 20.4169 4.25865 7.00012 13.125Z"></path>
              </svg>
              SAVE{" "}
            </a>
            <a className="primary-btn3" href="my-account/index.html">
              <svg
                width={16}
                height={16}
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14.4311 12.759C15.417 11.4291 16 9.78265 16 8C16 3.58169 12.4182 0 8 0C3.58169 0 0 3.58169 0 8C0 12.4182 3.58169 16 8 16C10.3181 16 12.4058 15.0141 13.867 13.4387C14.0673 13.2226 14.2556 12.9957 14.4311 12.759ZM13.9875 12C14.7533 10.8559 15.1999 9.48009 15.1999 8C15.1999 4.02355 11.9764 0.799983 7.99991 0.799983C4.02355 0.799983 0.799983 4.02355 0.799983 8C0.799983 9.48017 1.24658 10.8559 2.01245 12C2.97866 10.5566 4.45301 9.48194 6.17961 9.03214C5.34594 8.45444 4.79998 7.49102 4.79998 6.39995C4.79998 4.63266 6.23271 3.19993 8 3.19993C9.76729 3.19993 11.2 4.63266 11.2 6.39995C11.2 7.49093 10.654 8.45444 9.82039 9.03206C11.5469 9.48194 13.0213 10.5565 13.9875 12ZM13.4722 12.6793C12.3495 10.8331 10.3188 9.59997 8.00008 9.59997C5.68126 9.59997 3.65049 10.8331 2.52776 12.6794C3.84829 14.2222 5.80992 15.2 8 15.2C10.1901 15.2 12.1517 14.2222 13.4722 12.6793ZM8 8.79998C9.32551 8.79998 10.4 7.72554 10.4 6.39995C10.4 5.07444 9.32559 3.99992 8 3.99992C6.6744 3.99992 5.59997 5.07452 5.59997 6.40003C5.59997 7.72554 6.67449 8.79998 8 8.79998Z"
                />
              </svg>
              SIGN UP{" "}
            </a>
          </div>
          <div className="hotline-area d-lg-none d-flex">
            <div className="icon">
              <img
                src="wp-content/plugins/arjanMotors-core/inc/theme-options/images/icon/hotline-icon.svg"
                alt=""
              />
            </div>
            <div className="content">
              <span>To More Inquiry</span>
              <h6>
                <a href="tel:917992990999">+917992990999</a>
              </h6>
            </div>
          </div>
        </div>
        <div
          className="nav-right d-flex jsutify-content-end align-items-center "
          onClose={toggleDrawer}
        >
          {/* Button trigger modal */}
          {/* <div className="dropdown">
            <button className="modal-btn header-cart-btn" type="button">
              <i className="bi bi-bag-check" /> Compare
            </button>
          </div> */}
          <div className="hotline-area d-xl-flex d-none">
            <div className="icon">
              <img
                // src="wp-content/plugins/arjanMotors-core/inc/theme-options/images/icon/hotline-icon.svg"
                alt=""
              />
            </div>
            <i
              className="bi bi-telephone"
              style={{ fontSize: "30px", color: "silver" }}
              aria-hidden="true"
            ></i>
            <div className="content">
              <span>To More Inquiry</span>
              <h6>
                <a href="tel:917992990999">+917992990999</a>
              </h6>
            </div>
          </div>
          <div className="search-icon">
            <i
              class="fa fa-search"
              aria-hidden="true"
              style={{ fontSize: "22px", color: "#fff" }}
              onClick={() => handleSearchBar()}
            ></i>
          </div>

          <div className="lg:hidden">
            <div className="dropdown" style={{ color: "black" }}>
              <label>
                <div
                  tabIndex={0}
                  className="btn btn-ghost sidebar-button mobile-menu-btn"
                  onClick={toggleDrawer}
                >
                  <span />
                </div>
              </label>

              <Drawer
                open={isOpen}
                onClose={toggleDrawer}
                direction="left"
                className="drawer-mobile"
              >
                <div
                  style={{ background: "rgb(42,43,48)" }}
                  className="main-menu dropdown-content mt-3 p-2 shadow bg-base-300"
                >
                  <div>
                    <div className="">
                      {user ? (
                        <div className="mobile-user-avatar">
                          <div class="avatar">
                            <div class="w-10 rounded-full ring ring-offset-base-50 ring-offset-10">
                              <Link to="/dashboard">
                                <img
                                  className="rounded-full"
                                  src={user?.photoURL}
                                  alt={user?.displayName}
                                  width={30}
                                  height={30}
                                />
                              </Link>
                            </div>
                          </div>
                          <div>
                            <Link to="/dashboard">
                              {" "}
                              <p className="text-white font-md">
                                {user.displayName}
                              </p>
                            </Link>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <ul id="menu-main-menu" className="menu-list">
                        <li
                          id="menu-item-40"
                          className="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home current-menu-ancestor current-menu-parent menu-item-has-children menu-item-40"
                        >
                          <Link
                            to="/"
                            onClick={toggleCloseDrawer}
                            aria-current="page"
                          >
                            Home
                          </Link>
                        </li>
                        <li
                          id="menu-item-1295"
                          className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children has-mega-menu menu-item-1295"
                        >
                          <Link to="/about" onClick={toggleCloseDrawer}>
                            About us
                          </Link>
                        </li>
                        <li
                          id="menu-item-1468"
                          className="menu-item menu-item-type-taxonomy menu-item-object-vehicle-category menu-item-1468"
                        >
                          <Link to="/cars" onClick={toggleCloseDrawer}>
                            Car Inventory
                          </Link>
                        </li>
                        <li
                          id="menu-item-48"
                          className="menu-item menu-item-type-post_type menu-item-object-page menu-item-48"
                        >
                          <Link to="/contact-us" onClick={toggleCloseDrawer}>
                            Contact Us
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={
                              userAccessToken
                                ? "/dashboard/add-product"
                                : "/login"
                            }
                            onClick={
                              userAccessToken ? toggleCloseDrawer : handleToast
                            }
                            activeClassName="active"
                          >
                            Sell With Us
                          </Link>
                        </li>

                        {user ? (
                          <li>
                            <Link to="/contact-us" onClick={handleLogOut}>
                              Logout
                            </Link>
                          </li>
                        ) : (
                          ""
                        )}
                      </ul>
                    </div>
                    {user ? (
                      ""
                    ) : (
                      <div className="topbar-right d-lg-none d-block">
                        <Link
                          to="/login"
                          onClick={toggleCloseDrawer}
                          className="primary-btn3"
                          href="my-account/index.html"
                          style={{
                            display: "inline-flex",
                            margin: "0.35rem",
                            gap: "10px",
                          }}
                        >
                          <svg
                            width={16}
                            height={16}
                            viewBox="0 0 16 16"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M14.4311 12.759C15.417 11.4291 16 9.78265 16 8C16 3.58169 12.4182 0 8 0C3.58169 0 0 3.58169 0 8C0 12.4182 3.58169 16 8 16C10.3181 16 12.4058 15.0141 13.867 13.4387C14.0673 13.2226 14.2556 12.9957 14.4311 12.759ZM13.9875 12C14.7533 10.8559 15.1999 9.48009 15.1999 8C15.1999 4.02355 11.9764 0.799983 7.99991 0.799983C4.02355 0.799983 0.799983 4.02355 0.799983 8C0.799983 9.48017 1.24658 10.8559 2.01245 12C2.97866 10.5566 4.45301 9.48194 6.17961 9.03214C5.34594 8.45444 4.79998 7.49102 4.79998 6.39995C4.79998 4.63266 6.23271 3.19993 8 3.19993C9.76729 3.19993 11.2 4.63266 11.2 6.39995C11.2 7.49093 10.654 8.45444 9.82039 9.03206C11.5469 9.48194 13.0213 10.5565 13.9875 12ZM13.4722 12.6793C12.3495 10.8331 10.3188 9.59997 8.00008 9.59997C5.68126 9.59997 3.65049 10.8331 2.52776 12.6794C3.84829 14.2222 5.80992 15.2 8 15.2C10.1901 15.2 12.1517 14.2222 13.4722 12.6793ZM8 8.79998C9.32551 8.79998 10.4 7.72554 10.4 6.39995C10.4 5.07444 9.32559 3.99992 8 3.99992C6.6744 3.99992 5.59997 5.07452 5.59997 6.40003C5.59997 7.72554 6.67449 8.79998 8 8.79998Z"
                            />
                          </svg>
                          SIGN UP{" "}
                        </Link>
                      </div>
                    )}
                  </div>
                  <div className="flex justify-center gap-2 mt-3 items-center">
                    <div className="icon mobile-drawer-phone">
                      <svg
                        width={32}
                        height={32}
                        viewBox="0 0 32 32"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M31.1603 24.6852L24.6834 20.3658C23.8615 19.8221 22.7597 20.001 22.152 20.7769L20.2654 23.2027C20.1481 23.3573 19.9789 23.4645 19.789 23.5045C19.599 23.5444 19.4011 23.5145 19.2314 23.4203L18.8725 23.2224C17.6828 22.574 16.2025 21.7667 13.22 18.7831C10.2375 15.7995 9.42859 14.3181 8.78012 13.1306L8.58334 12.7717C8.48781 12.6021 8.45678 12.4037 8.49597 12.213C8.53516 12.0223 8.64193 11.8522 8.79662 11.734L11.2208 9.84792C11.9964 9.2402 12.1756 8.13874 11.6324 7.31655L7.31309 0.83963C6.75648 0.00237835 5.63977 -0.24896 4.77809 0.269026L2.06967 1.89597C1.21867 2.39626 0.594346 3.20652 0.327557 4.15695C-0.647737 7.71055 0.0859667 13.8435 9.12038 22.879C16.3071 30.0651 21.6572 31.9976 25.3345 31.9976C26.1809 32.0013 27.0239 31.8912 27.8409 31.6703C28.7915 31.4038 29.6018 30.7794 30.1018 29.9281L31.7304 27.2214C32.2491 26.3595 31.9979 25.2421 31.1603 24.6852ZM30.8115 26.6742L29.1867 29.3826C28.8277 29.997 28.2449 30.4488 27.5603 30.6432C24.2797 31.5439 18.5483 30.7979 9.87489 22.1245C1.20149 13.4511 0.455538 7.72017 1.35622 4.4391C1.55097 3.75367 2.00324 3.17011 2.61841 2.81053L5.32682 1.1857C5.7007 0.960737 6.18538 1.06978 6.4269 1.4331L8.77324 4.95577L10.7426 7.90946C10.9784 8.26609 10.9009 8.74409 10.5645 9.00798L8.13978 10.8941C7.40188 11.4583 7.19117 12.4792 7.64547 13.2895L7.83801 13.6393C8.51953 14.8892 9.36684 16.4442 12.4603 19.5371C15.5537 22.63 17.1081 23.4773 18.3575 24.1588L18.7078 24.3518C19.518 24.8061 20.539 24.5954 21.1032 23.8575L22.9893 21.4328C23.2533 21.0966 23.7311 21.0191 24.0879 21.2547L30.5642 25.5741C30.9278 25.8154 31.0368 26.3004 30.8115 26.6742ZM18.1324 5.33496C23.1367 5.34053 27.1921 9.39599 27.1977 14.4003C27.1977 14.6948 27.4364 14.9335 27.7309 14.9335C28.0255 14.9335 28.2642 14.6948 28.2642 14.4003C28.258 8.8072 23.7255 4.27462 18.1324 4.2685C17.8378 4.2685 17.5991 4.50721 17.5991 4.80173C17.5991 5.09625 17.8378 5.33496 18.1324 5.33496Z" />
                        <path d="M18.1324 8.53424C21.3704 8.53805 23.9944 11.162 23.9982 14.4001C23.9982 14.5415 24.0544 14.6771 24.1544 14.7771C24.2544 14.8771 24.39 14.9333 24.5314 14.9333C24.6728 14.9333 24.8085 14.8771 24.9085 14.7771C25.0085 14.6771 25.0646 14.5415 25.0646 14.4001C25.0602 10.5733 21.9591 7.47215 18.1324 7.46777C17.8378 7.46777 17.5991 7.70649 17.5991 8.00101C17.5991 8.29553 17.8378 8.53424 18.1324 8.53424Z" />
                        <path d="M18.1324 11.7344C19.6041 11.7362 20.7968 12.9289 20.7986 14.4007C20.7986 14.5422 20.8548 14.6778 20.9548 14.7778C21.0548 14.8778 21.1905 14.934 21.3319 14.934C21.4733 14.934 21.6089 14.8778 21.7089 14.7778C21.8089 14.6778 21.8651 14.5422 21.8651 14.4007C21.8627 12.3402 20.1929 10.6703 18.1324 10.668C17.8378 10.668 17.5991 10.9067 17.5991 11.2012C17.5991 11.4957 17.8378 11.7344 18.1324 11.7344Z" />
                      </svg>
                    </div>
                    <div>
                      <div>
                        <a href="tel:+919009005165" className="text-white">
                          +919009005165
                        </a>
                      </div>
                      <div>
                        <a href="tel:+917992990999" className="text-white">
                          +917992990999
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </Drawer>
            </div>
          </div>
        </div>
      </header>
      {searchBarSection && (
        <div className="mobile-searchbar">
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search by Make or Model"
            />
            <HashLink to={`/cars?search=${search}#cars-section`}>
            <div className="input-group-append">
              <span
                className="input-group-text"
                id="basic-addon2"
                // onClick={(e) => handleSubmit(e)}
              >
                <i className="bi bi-search" />
              </span>
            </div>
            </HashLink>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
